import React, { ReactNode } from 'react'
import { TabControls } from '@features/imperativeModals'

import { CustomPopupProps } from './CustomPopup'
import { Spacer } from '../../design-system/Spacer'
import { Tab } from '../../design-system/Tab'

export type TabDefinition = {
  id: string
  label: string
  renderContent: () => ReactNode
  customFooter?: ReactNode
}

type ReturnedProps = {
  children: CustomPopupProps['children']
  title: NonNullable<CustomPopupProps['title']>
  footer?: CustomPopupProps['footer']
}

/**
 *  A helper function to provide multi-tab behaviour to CustomPopup
 *  Spread this AFTER providing shared `footer` prop.
 */
export function customPopupTabs(
  sections: TabDefinition[],
  [activeTab, setActiveTab]: TabControls
): ReturnedProps {
  const activeSection = sections.find(section => section.id === activeTab)

  const title: ReturnedProps['title'] = (
    <span css="display: inline-flex">
      <Spacer marginLeft="-10px" order={-1} />

      {sections?.map(section => (
        <Tab
          size={18}
          label={section.label}
          active={activeTab === section.id}
          onClick={() => setActiveTab(section.id)}
          dataTest={`custom-popup-tab custom-popup-tab--${section.id}`}
          key={section.id}
        />
      ))}
    </span>
  )

  const children: ReturnedProps['children'] = activeSection?.renderContent?.()

  return activeSection?.customFooter
    ? { title, children, footer: activeSection.customFooter }
    : { title, children }
}
